import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { LogoInline } from "@/components/Logo";

const NAV = [
  { label: "Services", href: "#services" },
  { label: "Why Us", href: "#why" },
  { label: "Pricing", href: "#pricing" },
  { label: "Reviews", href: "#reviews" },
  { label: "FAQ", href: "#faq" },
];

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (href) => {
    setOpen(false);
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#f5ede1]/90 backdrop-blur-md border-b border-[#d9c9b2]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <button
          onClick={() => scrollTo("#top")}
          data-testid="header-logo-btn"
          aria-label="Back to top"
        >
          <LogoInline />
        </button>

        <nav className="hidden md:flex items-center gap-9">
          {NAV.map((item) => (
            <button
              key={item.href}
              onClick={() => scrollTo(item.href)}
              className="font-sans-body text-[13px] font-semibold uppercase tracking-[0.18em] text-[#3b2a1f] hover:text-[#c63027] transition-colors"
              data-testid={`nav-${item.label.toLowerCase().replace(" ", "-")}`}
            >
              {item.label}
            </button>
          ))}
        </nav>

        <div className="hidden md:block">
          <button
            onClick={() => scrollTo("#contact")}
            data-testid="header-quote-btn"
            className="pill-btn bg-[#c63027] hover:bg-[#a8231b] text-[#fbf3e6] h-11 px-6 text-sm transition-colors shadow-sm"
          >
            ★ Free Quote
          </button>
        </div>

        <button
          className="md:hidden p-2 text-[#3b2a1f]"
          onClick={() => setOpen((s) => !s)}
          aria-label="Toggle menu"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X className="size-6" /> : <Menu className="size-6" />}
        </button>
      </div>

      {open && (
        <div
          className="md:hidden bg-[#f5ede1] border-b border-[#d9c9b2]"
          data-testid="mobile-menu"
        >
          <div className="px-6 py-4 flex flex-col gap-2">
            {NAV.map((item) => (
              <button
                key={item.href}
                onClick={() => scrollTo(item.href)}
                className="text-left font-sans-body font-semibold uppercase tracking-[0.18em] text-sm text-[#3b2a1f] py-3 border-b border-[#d9c9b2]/60"
                data-testid={`mobile-nav-${item.label.toLowerCase().replace(" ", "-")}`}
              >
                {item.label}
              </button>
            ))}
            <button
              onClick={() => scrollTo("#contact")}
              data-testid="mobile-quote-btn"
              className="pill-btn mt-3 bg-[#c63027] text-[#fbf3e6] h-11 px-6 self-start text-sm"
            >
              ★ Free Quote
            </button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
